module.exports = {
      id: "app-store-usage",
      viewBox: "0 0 144 48",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#app-store",
      toString: function () {
        return this.url;
      }
    }